/*
IMPORTANT: READ BEFORE ADDING NEW FLAG
If you would like your flag to be sent to our analytics services, you must also add the flag
to FEATURE_FLAGS_ANALYTICS_LIST.
*/

// Rollouts
export const ROLLOUT_AT_MENTION_COMMENT = 'rollout-at-mention-comment';
export const ROLLOUT_EXTERNAL_AT_MENTION = 'rollout-external-at-mention';
export const ROLLOUT_FILE_ATTACHMENTS = 'rollout-file-attachments';
export const ROLLOUT_LOOM_ACTIVITY_FEED = 'rollout-loom-activity-feed';
export const ROLLOUT_WEBSITE_RECORDING = 'rollout-website-recording';
export const ROLLOUT_GRAPHQL_GET_VIDEOS_DASHBOARD =
  'rollout-graphql-get-videos-dashboard';
export const ROLLOUT_DUPLICATE_FOLDER = 'rollout-duplicate-folder';
export const ROLLOUT_DELIGHT_LOOM_TV = 'rollout-delight-loom-tv';
export const ROLLOUT_SHOW_DEACTIVATE_MEMBER_BUTTON =
  'rollout-show-deactivate-member-button';
export const ROLLOUT_DECODE_DURATION = 'rollout-decode-duration';
export const ROLLOUT_VIDEO_UPLOADS = 'rollout-video-uploads';
export const ROLLOUT_COMPANY_DEFAULT_WORKSPACE =
  'rollout-company-default-workspace';
export const ROLLOUT_COMPANY_DEFAULT_WORKSPACE_UI =
  'rollout-company-default-workspace-ui';
export const ROLLOUT_COMPANY_AUTH_CONFIG = 'rollout-company-auth-config';
export const ROLLOUT_COMPANY_SCIM_SETTINGS = 'rollout-company-scim-settings';
export const ROLLOUT_COMPANY_TEST_SSO_CONNECTION =
  'rollout-company-test-sso-connection';
export const ROLLOUT_COMPANY_SSO_GSUITE = 'rollout-company-sso-gsuite';
export const ROLLOUT_COMPANY_SSO_AZURE = 'rollout-company-sso-azure';
export const ROLLOUT_COMPANY_SSO_ONELOGIN = 'rollout-company-sso-onelogin';
export const ROLLOUT_COMPANY_SSO_AUTH0 = 'rollout-company-sso-auth-0';
export const ROLLOUT_COMPANY_SSO_ADFS = 'rollout-company-sso-adfs';
export const ROLLOUT_COMPANY_SSO_OKTA_OIN = 'rollout-company-sso-okta-oin';
export const ROLLOUT_VIRUS_SCAN = 'rollout-virus-scan';
export const ROLLOUT_VIDEO_LIMIT_BANNER = 'rollout-video-limit-banner';
export const ROLLOUT_RECORDING_TIMER = 'rollout-recording-timer';
export const ROLLOUT_CLOSED_CAPTIONS = 'rollout-closed-captions';
export const STORE_FILLER_WORD_RANGES = 'store-filler-word-ranges';
export const ROLLOUT_BILLING_DETAILS = 'rollout-billing-details';
export const ROLLOUT_WAVEFORM = 'rollout-waveform';
export const ROLLOUT_WAVEFORM_GENERATION = 'rollout-waveform-generation';
export const ROLLOUT_BILLING_MARK_UNCOLLECTIBLE_INVOICES_AS_VOID =
  'rollout-billing-mark-uncollectible-invoices-as-void';
export const ROLLOUT_BILLING_NEW_SALES_LED_STRIPE_PRODUCT =
  'rollout-billing-new-sales-led-stripe-product';
export const ROLLOUT_INSTANT_EDITING = 'rollout-instant-editing';
export const ROLLOUT_JIT_HLS_NOTRIMMING = 'rollout-jit-hls-notrimming';
export const ROLLOUT_JIT_NOISECANCELLATION_MODEL =
  'rollout-jit-hls-noise-cancellation-model';

export const ROLLOUT_JIT_DASH_TO_HLS = 'rollout-jit-dash-to-hls';
export const ROLLOUT_AVSERVER_METRIC_TAGS = 'rollout-avserver-metric-tags';

export const ROLLOUT_NOISE_SUPPRESSION = 'rollout-noise-suppression';

export const DISABLE_JIT_HLS_FOR_ANDROID = 'disable-jit-hls-for-android';
export const ROLLOUT_SHOW_REACTION_FLURRIES = 'rollout-show-reaction-flurries';
export const ROLLOUT_WELCOME_LOOM = 'rollout-welcome-loom';
export const ROLLOUT_VIDEO_PLAYER_PRE_PLAY_SCREEN =
  'rollout-video-player-pre-play-screen';
export const ROLLOUT_VIDEO_PLAYER_END_SCREEN =
  'rollout-video-player-end-screen';
export const ROLLOUT_SLACK_IDENTITY_LINKS = 'rollout-slack-identity-links';
export const ROLLOUT_SLACK_IDENTITY_LINKS_ONBOARDING_MODAL =
  'rollout-slack-identity-links-onboarding-modal';
export const ROLLOUT_CHAT_CREATE = 'rollout-chat-create';
export const ROLLOUT_RECORD_SUPPORT_VIDEO = 'rollout-record-support-video';
export const ROLLOUT_DATA_RETENTION_UI = 'rollout-data-retention-ui';
export const ROLLOUT_DATA_RETENTION_CIRCUIT_BREAKER =
  'rollout-data-retention-circuit-breaker';
export const ROLLOUT_DATA_RETENTION_DELETION_LIMIT =
  'rollout-data-retention-deletion-limit';
export const ROLLOUT_DATA_RETENTION_DRY_RUN = 'rollout-data-retention-dry-run';
export const ROLLOUT_WORKSPACE_DIGEST = 'rollout-workspace-digest';
export const ROLLOUT_SLACK_SHARED_AUTH_PRIVATE =
  'rollout-slack-shared-auth-for-private-videos';
export const ROLLOUT_SLACK_SHARED_AUTH_PUBLIC =
  'rollout-slack-shared-auth-for-public-videos';
export const ROLLOUT_ANONYMOUS_SHARE_PAGE_EDU_BUSINESS =
  'rollout-anonymous-share-page-edu-business';
export const ROLLOUT_SIGNUP_MODAL_FROM_SHARE_PAGE =
  'rollout-signup-modal-from-share-page';
export const ROLLOUT_NEW_ANONYMOUS_REACTION_NAME_INPUT =
  'rollout-new-anonymous-reaction-name-input';
export const ROLLOUT_AUDIT_LOG_EXPORT = 'rollout-audit-log-export';
export const ROLLOUT_WORKSPACE_GROUPS = 'rollout-workspace-groups';
export const ROLLOUT_CONTENT_PRIVACY_RESTRICTIONS =
  'rollout-content-privacy-restrictions';
export const ROLLOUT_PRIVATE_VIDEO_PREVIEW = 'rollout-private-video-preview';
export const ROLLOUT_MEMBERS_UI_REFRESH = 'rollout-members-ui-refresh';
export const SUGGEST_PUBLISH_ON_PUBLIC_CHANNEL_LOOM_SHARE =
  'rollout-suggest-publish-links-shared-public-slack';
export const ROLLOUT_DESTINATION_FEED_V2 = 'rollout-destination-feed-v2';
export const NOTIFY_ADMIN_DEFAULT_PRIVACY_CHANGE =
  'notify-admin-default-privacy-change';
export const ROLLOUT_WORKSPACE_CONTACT_SYNC_SLACK =
  'rollout_workspace_contact_sync_slack';
export const ROLLOUT_WORKSPACE_CONTACT_SYNC_GOOGLE =
  'rollout-workspace-contact-sync-google';
export const GOOGLE_CONTACTS_SYNC_PAGE_LIMIT =
  'google-contacts-sync-page-limit';
export const GOOGLE_CONTACTS_SYNC_WORKSPACE_LIMIT =
  'google-contacts-sync-workspace-limit';
export const ROLLOUT_ACCOUNT_SUSPENSION_LACK_OF_PAYMENT =
  'rollout-account-suspension-lack-of-payment';
export const ROLLOUT_DESTINATION_HOMEFEED_NEWPLAYER =
  'rollout-destination-home-feed-newplayer';
export const ROLLOUT_WORKSPACE_CONTENT_TRANSFER =
  'rollout-workspace-content-transfer';
export const ROLLOUT_WORKSPACE_DOMAIN_USER_REPORTS =
  'rollout-workspace-domain-user-reports';
export const ROLLOUT_V4_AVSERVER = 'rollout-v4-avserver';

export const EXP_DESTINATION_EXPANDED_BETA =
  'experiment-destination-expanded-beta';
export const EXP_DESTINATION_EXPANDED_BETA_VARIANTS = [
  'variant-new',
  'variant-existing',
  'variant-excluded',
];

export const DESTINATION_RELATED_VIDEOS = 'destination-related-videos';

export const EXP_VIEWFINDER_PROTOTYPE = 'exp-viewfinder-prototype';

// Killswitches and overrides.
export const QUEUE_BASE_TRANSCODER_V3_INCLUDE_HLS =
  'qbase_transcoder_v3_include_hls';

// Experiments
export const EXPERIMENT_SHARE_WITH_LOOM_TEAM =
  'experiment-share-with-loom-team';
export const EXPERIMENT_ACTIVITY_FEED = 'rollout-activity-feed-experiment';
export const EXP_MOBILE_NUDGE_IN_ONBOARDING_CHECKLIST =
  'experiment-website-mobile-nudge-in-onboarding-checklist';
export const PROOT_UPLOAD_FFMPEG = 'experiment-proot-upload-ffmpeg';

// growth experiments
export const EXP_VIDEO_LIMIT_PAYWALL = 'grow-video-limit-paywall-v3';
export const GROW_DASHBOARD_NAV_PRICING_LINKS =
  'grow-dashboard-nav-pricing-links-2';
export const GROW_ACT_CLARIFY_TRIAL = 'grow-act-clarify-trial';
export const GROW_PRICING_HEADER_COPY = 'grow-pricing-header-copy-2';
export const GROW_ENGAGE_REMOVE_VIEWER_INFO_BARRIER =
  'grow-engage-remove-viewer-info-barrier';
export const GROW_ACT_GET_STARTED = 'grow-act-get-started';
export const GROW_RICHER_FIRST_VIEW_EMAIL = 'grow-richer-first-view-email';
export const GROW_DASHBOARD_RECORD_BUTTON = 'grow-dashboard-record-button';
export const GROW_END_OF_VIDEO_REPLY_CTA = 'grow-end-of-video-reply-cta-3';
export const EXP_FIRST_VIDEO_SHARE_MODAL =
  'experiment-website-show-share-modal';
export const EXP_SIGNUP_MODAL_SHARE_PAGE =
  'experiment-website-signup-modal-from-share-page';
export const EXP_INVITE_MAGIC_LINK = 'experiment_website_invite_magic_link';
export const ROLLOUT_INVITE_MAGIC_LINK_WELCOME_FLOW =
  'rollout_website_invite_magic_link_welcome_flow';
export const EXPERIMENT_SINGLE_DOMAIN_WORKSPACE =
  'experiment-single-domain-workspace';
export const EXP_PERSISTENT_RECORD_BUTTON_SIGNED_IN =
  'experiment-website-persistent-record-button-signed-in';
export const EXP_PERSISTENT_RECORD_BUTTON_SIGNED_OUT =
  'experiment-website-persistent-record-button-signed-out';
export const EXP_SDK_IN_ONBOARDING = 'experiment-website-sdk-in-onboarding';
export const EXP_INVITE_STORAGE_INCENTIVES =
  'experiment-website-storage-incentives';
export const EXP_INVITE_STORAGE_INCENTIVES_V2 =
  'experiment-website-storage-incentives-v2';
export const EXP_INVITE_STORAGE_INCENTIVES_ROLLOUT =
  'experiment-website-storage-incentives-rollout';
export const EXP_JOIN_WORKSPACE_FROM_SHARE_PAGE =
  'experiment-website-join-workspace-from-share-page';
export const EXP_GOOGLE_ONE_TAP_SHARE_PAGE =
  'website-experiment-google-one-tap-share-page';
export const EXP_GOOGLE_ONE_TAP_SIGNUP_LOGIN =
  'website-experiment-google-one-tap-signup-login';
export const EXP_SWIMLANES_AA = 'swimlanes-AA';
export const EXP_ANON_SWIMLANES_AA = 'anon-swimlanes-AA';
export const EXP_CONSOLIDATE_SIGNUP_MODAL =
  'experiment-consolidate-signup-modal';
export const EXP_MORE_OPINIONATED_OAUTH_ON_SIGNUP_PAGE =
  'experiment-more-opinionated-oauth-on-signup-page-2';
export const EXP_MORE_OPINIONATED_OAUTH_ON_SIGNUP_PAGE_MOBILE =
  'experiment-more-opinionated-oauth-on-signup-page-mobile-2';
export const EXP_SHARE_PAGE_END_OF_VIDEO_NUDGES =
  'experiment-website-end-of-video-nudges';
export const EXP_EMBED_END_OF_VIDEO_NUDGES =
  'experiment-embed-end-of-video-nudges-3';
export const EXP_SHARE_PAGE_PAUSE_VIDEO_NUDGES =
  'experiment-website-pause-video-nudges';
export const EXP_EMBED_PAUSE_VIDEO_NUDGES =
  'experiment-embed-pause-video-nudges-2';
export const EXP_INVITE_MODAL_UPDATE = 'experiment-website-invite-modal-update';
export const EXP_EMAIL_VERIFICATION_REMINDER =
  'experiment-backend-email-verification-reminder';
export const EXP_INVITE_MODAL_UPDATE_MOBILE =
  'experiment-website-invite-modal-update-mobile';
export const EXP_NEW_CTA_AND_VALUE_PROP_ON_SHARE_PAGE =
  'experiment-new-cta-and-value-prop-on-share-page';
export const EXP_INVITE_LINK_ONBOARDING =
  'experiment-website-invite-link-onboarding';

// When extension goes down
export const DISABLE_EXTENSION_DOWNLOAD =
  'disable-chrome-extension-download-when-down';

// Video stats
export const SEND_HLS_PLAYBACK_STATS = 'send_hls_playback_stats';

export const SHOW_MARKETING_BANNER = 'show-marketing-banner';
export const MARKETING_BANNER_COPY = 'marketing-banner-copy';

// Domain Status Update tool
export const ADMIN_DOMAIN_STATUS_PROCESS_LIMIT =
  'admin-domain-status-process-limit';

// /Permanent Admin Portal Flags
export const PERMANENT_BILLING_DEBUGGER = 'permanent-billing-debugger';
export const PERMANENT_CAN_CHANGE_SALES_SUPPORT_TYPE =
  'permanent-can-change-sales-support-type';

export const MULTIPLE_WORKSPACES = 'multiple-workspaces';

// Video Uploads
export const VIDEO_UPLOADS_FILE_SIZE_LIMIT = 'video-uploads-file-size-limit';

// Recover Videos
export const ROLLOUT_RECOVER_VIDEOS = 'rollout-recover-videos';

// Mobile
export const SHOW_MOBILE_APP_CARD = 'mobile-app-card';
export const ANDROID_AUDIO_ONLY_LOOMS = 'android-audio-only-looms';
export const IOS_AUDIO_ONLY_LOOMS = 'ios-audio-only-looms';

export const DARK_MODE_TOGGLE = 'dark-mode-toggle';

export const DEFAULT_TEAM_ACCOUNT_TYPE = 'default-team-accounts';

// Integrations
export const ROLLOUT_INTEGRATIONS_LISTING = 'rollout-integrations-listing';
export const ROLLOUT_INTEGRATIONS_DATASYNC = 'rollout-integrations-datasync';
export const ROLLOUT_INTEGRATIONS_ZOOM = 'rollout-integration-zoom';
export const ROLLOUT_INTEGRATIONS_ZOOM_NOTIFICATION =
  'rollout-integration-zoom-notification';
export const ROLLOUT_INTEGRATIONS_ZOOM_GA_UI = 'rollout-integration-zoom-ga-ui';

export const ROLLOUT_SLACK_NOTIFICATIONS = 'rollout-slack-notifications';

export const ROLLOUT_DASHBOARD_WATCH_LATER = 'rollout-dashboard-watch-later';

export const HIDE_DURING_DOWNTIME = 'hide-during-downtime';

export const ROLLOUT_WORKSPACE_CONSOLIDATE = 'rollout-workspace-consolidate';
export const ROLLOUT_WORKSPACE_CONSOLIDATE_ADMIN_SETTINGS =
  'rollout-workspace-consolidate-admin-settings';
export const ROLLOUT_WORKSPACE_CONSOLIDATE_EXISTING_USERS =
  'rollout-workspace-consolidate-teams-for-existing-users';
export const ROLLOUT_WORKSPACE_CONSOLIDATE_EXISTING_USERS_SIDEBAR =
  'rollout-workspace-consolidate-teams-for-existing-users-sidebar';
export const ROLLOUT_WORKSPACE_CONSOLIDATE_EXISTING_USERS_SELECTOR =
  'rollout-workspace-consolidate-teams-for-existing-users-selector';
export const ROLLOUT_AUTO_JOIN_AT_REGISTRATION =
  'rollout-auto-join-at-registration';

export const ROLLOUT_AUTOJOIN_SIDEBAR = 'rollout-autojoin-sidebar';

export const ROLLOUT_ONESIGNAL_NOTIFICATIONS =
  'rollout-onesignal-notifications';

export const CONFIG_HLS_JS_PLAYER = 'config-hls-js-player';
export const CONFIG_WELCOME_LOOMS_IDS = 'config-welcome-looms-ids';
export const CONFIG_ANON_SHARE_PAGE_LOOMS_IDS =
  'config-anon-share-page-looms-ids';

export const ROLLOUT_DESKTOP_NOTIES = 'rollout-desktop-noties';
export const MENTION_PROCESSING_SHUTOFF =
  'at-mention-processing-emergency-shutoff';
// Crashed video collector
export const ROLLOUT_CRASHED_VIDEO_COLLECTOR =
  'rollout-crashed-video-collector';
export const ROLLOUT_CVC_DESTROY_VIDEO = 'rollout-cvc-destroy-video';

export const ROLLOUT_CANVAS = 'rollout-canvas';
export const ROLLOUT_CANVAS_DESKTOP = 'rollout-canvas-desktop';

export const ENABLE_CUSTOM_INVOICE = 'enable-custom-invoice';
export const ENABLE_ACCOUNT_RENEWAL_NOTICE = 'enable-account-renewal';

export const ROLLOUT_CAM_BUBBLE_ON_BOARDING =
  'rollout-cam-bubble-on-boarding-0';
export const DISABLE_EXTENSION_NOTIFICATIONS =
  'disable-extension-notifications';

export const ROLLOUT_DEPRECATE_SPECIAL_FOLDERS =
  'rollout-deprecate-special-folders';

export const ROLLOUT_DEVELOPER_PORTAL_SDK_CUSTOM_CONCEPT =
  'rollout-developer-portal-sdk-custom-concept';

// desktop app upload proxy
const ROLLOUT_S3_ACCELERATOR_BY_USER = 'rollout-s3-accelerator-by-user';
const ROLLOUT_STREAM_UPLOADER_GLOBAL = 'rollout-stream-uploader-global';
const ROLLOUT_STREAM_UPLOADER_WINDOWS_2 = 'rollout-stream-uploader-windows-2';
const ROLLOUT_STREAM_UPLOADER_MAC = 'rollout-stream-uploader-mac';

// camfort flags NOTE: these are not used directly in the loom repo, but need to be published to analytics
// they are used in the Chrome app, desktop app, and SDK
const ROLLOUT_CAMFORT_EXPERIMENT = 'project-camfort-experiment';
const ROLLOUT_CAMFORT_SDK = 'project-camfort-sdk';

export const ROLLOUT_CAMFORT_CHROME = 'project-camfort-chrome';
const ROLLOUT_CAMFORT_DESKTOP = 'project-camfort-desktop';

export const ROLLOUT_TRENDING_VIDEOS = 'rollout-trending-videos';
export const ROLLOUT_RECOMMENDED_VIDEOS = 'rollout-recommended-videos';
export const ROLLOUT_GENERATED_METADATA = 'rollout-generated-metadata-v4';
export const ROLLOUT_DEFAULT_TO_HOME_FEED = 'rollout-default-to-home-feed';

// Flags for Mandrill email
export const EXPERIMENT_EMAIL_ORG_INVITE_ACCEPTED =
  'experiment-email-org-invite-accepted';
export const EXPERIMENT_EMAIL_UNACCEPTED_ORG_INVITE_REMINDER =
  'experiment-email-unaccepted-org-invite-reminder';

// Flags for the SDK
export const ROLLOUT_GUEST_BOUNDARY = 'rollout-guest-boundary-middleware';
export const ROLLOUT_SDK_FTUX_ONBOARDING = 'rollout-sdk-ftux-onboarding';
export const ROLLOUT_SDK_PICTURE_IN_PICTURE_WITH_RECORD_REPLY =
  'rollout-sdk-picture-in-picture-with-record-reply';
export const ROLLOUT_SDK_PICTURE_IN_PICTURE_WITH_PERSISTENT_RECORD =
  'rollout-sdk-picture-in-picture-with-persistent-record';

export const ROLLOUT_CONTINUE_WATCHING = 'rollout-continue-watching';

// Member Limits Overrides
export const MEMBER_LIMITS_OVERRIDE_FLAG = 'rollout-member-limits-override';

// Weave
export const ROLLOUT_WEAVE = 'rollout-weave';

// Companion
export const EXPERIMENT_LOOM_COMPANION_BEAM = 'experiment-loom-companion-beam';

// Marketing site
export const MARKETING_SITE_THREAD_PRICING_PAGE =
  'experiment-marketing-site-thread-pricing-page';
export const MARKETING_SITE_THREAD_HOMEPAGE =
  'experiment-marketing-site-thread-homepage';
export const MARKETING_SITE_THREAD_HOMEPAGE_AB_v1 =
  'experiment-marketing-site-homepage-iterations';

export const ROLLOUT_SDK_PRIVATE_KEY = 'rollout-sdk-key-hardening-frontend';
export const ROLLOUT_SDK_PRIVATE_KEY_ROUTES =
  'rollout-sdk-key-hardening-backend';

// Links & Stickers
export const EXPERIMENT_RENAME_CTA = 'experiment-rename-cta';

export const ROLLOUT_TEXT_TO_SPEECH = 'rollout-text-to-speech';
export const ROLLOUT_TEXT_TO_SPEECH_VIEWING = 'rollout-text-to-speech-viewing';

// Adds authz middleware to Loommate Portal routes
export const ENABLE_OIDC_JWT_MIDDLEWARE = 'enable-oidc-jwt-middleware';

// WorkOS
export const ENABLE_WORKOS_SSO = 'enable-workos-sso'; // Service-level kill switch
export const ROLLOUT_WORKOS = 'rollout-workos';

export const WORKSPACE_JOIN_REQUEST_REFACTOR =
  'workspace-join-request-refactor';

export const ROLLOUT_GOOGLE_TOKEN_LOGIN = 'rollout-google-token-login';

export const FIX_PERSISTENT_RECORD_MULTIPLE_RECORDERS_TRIGGERING_NUMBER_VARIANT =
  'fix-persistent-record-multiple-recorders-triggering-number-variant';

// Transcription
export const ROLLOUT_TRANSCRIPT_DISPLAY = 'rollout-transcript-display';

export const TRANSCRIPTION_TEST_OVERRIDE = 'transcription-test-override';
export const ROLLOUT_TRANSCRIPTION_ENTERPRISE =
  'rollout-transcription-enterprise';
export const ROLLOUT_TRANSCRIPTION_BUSINESS = 'rollout-transcription-business';
export const ROLLOUT_TRANSCRIPTION_TO_ALL = 'rollout-transcription-to-all';
export const TRANSCRIPTION_DESTINATION_TYPE = 'transcription-destination-type';

export const TRANSCRIPTION_FLAGS = [
  TRANSCRIPTION_TEST_OVERRIDE,
  ROLLOUT_TRANSCRIPTION_ENTERPRISE,
  ROLLOUT_TRANSCRIPTION_BUSINESS,
  ROLLOUT_TRANSCRIPTION_TO_ALL,
  TRANSCRIPTION_DESTINATION_TYPE,
];

export const ROLLOUT_IN_TRANSCRIPT_SEARCH = 'rollout-in-transcript-search';
export const ROLLOUT_TRANSCRIPTION_CORRECTION =
  'rollout-transcription-correction';
export const TRANSCRIPTION_ORG_NAME_DICTIONARY =
  'transcription-org-name-dictionary';

export const VIDEO_PLAYER_FRESH = 'video-player-fresh';
export const RABBITMQ_CONSUMER_STARTUP_CONTROL = 'rabbitmq-consumer-startup';
export const RABBITMQ_CONSUMER_CONNECTION_RETRIES =
  'rabbitmq-consumer-connection-retries';
export const RABBITMQ_PUBLISHER_CONNECTION_RETRIES =
  'rabbitmq-publisher-connection-retries';

// Feature flags on this list will be sent to our analytics platforms.
// Only flags for which we'd like to track analytics calls should be on this list.

// This list also helps keep the cached flag data small. When you have
// enabled the flag for all or have deprecated a flag be sure to remove
// it from this list
export const FEATURE_FLAGS_ANALYTICS_LIST = [
  ANDROID_AUDIO_ONLY_LOOMS,
  IOS_AUDIO_ONLY_LOOMS,
  DISABLE_EXTENSION_NOTIFICATIONS,
  ROLLOUT_CANVAS,
  ROLLOUT_CANVAS_DESKTOP,
  MULTIPLE_WORKSPACES,
  ROLLOUT_WEBSITE_RECORDING,
  EXPERIMENT_SHARE_WITH_LOOM_TEAM,
  EXP_VIDEO_LIMIT_PAYWALL,
  GROW_DASHBOARD_NAV_PRICING_LINKS,
  GROW_ACT_CLARIFY_TRIAL,
  GROW_PRICING_HEADER_COPY,
  GROW_ENGAGE_REMOVE_VIEWER_INFO_BARRIER,
  GROW_ACT_GET_STARTED,
  GROW_RICHER_FIRST_VIEW_EMAIL,
  GROW_DASHBOARD_RECORD_BUTTON,
  GROW_END_OF_VIDEO_REPLY_CTA,
  ROLLOUT_SHOW_REACTION_FLURRIES,
  EXP_FIRST_VIDEO_SHARE_MODAL,
  ROLLOUT_WORKSPACE_CONSOLIDATE,
  ROLLOUT_WORKSPACE_CONSOLIDATE_EXISTING_USERS,
  ROLLOUT_WORKSPACE_CONSOLIDATE_EXISTING_USERS_SELECTOR,
  ROLLOUT_WORKSPACE_CONSOLIDATE_EXISTING_USERS_SIDEBAR,
  ROLLOUT_COMPANY_DEFAULT_WORKSPACE,
  ROLLOUT_COMPANY_DEFAULT_WORKSPACE_UI,
  ROLLOUT_DESKTOP_NOTIES,
  ROLLOUT_SIGNUP_MODAL_FROM_SHARE_PAGE,
  ROLLOUT_S3_ACCELERATOR_BY_USER,
  ROLLOUT_STREAM_UPLOADER_GLOBAL,
  ROLLOUT_STREAM_UPLOADER_WINDOWS_2,
  ROLLOUT_STREAM_UPLOADER_MAC,
  EXPERIMENT_ACTIVITY_FEED,
  EXP_SIGNUP_MODAL_SHARE_PAGE,
  ROLLOUT_CAM_BUBBLE_ON_BOARDING,
  ROLLOUT_CAMFORT_EXPERIMENT,
  ROLLOUT_CAMFORT_SDK,
  ROLLOUT_CAMFORT_CHROME,
  ROLLOUT_CAMFORT_DESKTOP,
  ROLLOUT_WAVEFORM,
  EXP_INVITE_MAGIC_LINK,
  EXP_PERSISTENT_RECORD_BUTTON_SIGNED_IN,
  EXP_PERSISTENT_RECORD_BUTTON_SIGNED_OUT,
  MEMBER_LIMITS_OVERRIDE_FLAG,
  EXP_SDK_IN_ONBOARDING,
  ROLLOUT_WEAVE,
  ROLLOUT_TRANSCRIPTION_CORRECTION,
  EXP_INVITE_STORAGE_INCENTIVES,
  EXP_INVITE_STORAGE_INCENTIVES_V2,
  EXP_INVITE_STORAGE_INCENTIVES_ROLLOUT,
  EXPERIMENT_LOOM_COMPANION_BEAM,
  ROLLOUT_SDK_PRIVATE_KEY,
  ROLLOUT_SDK_PRIVATE_KEY_ROUTES,
  ROLLOUT_GENERATED_METADATA,
  ROLLOUT_SDK_FTUX_ONBOARDING,
  EXP_JOIN_WORKSPACE_FROM_SHARE_PAGE,
  EXP_DESTINATION_EXPANDED_BETA,
  EXP_MOBILE_NUDGE_IN_ONBOARDING_CHECKLIST,
  EXPERIMENT_EMAIL_ORG_INVITE_ACCEPTED,
  EXPERIMENT_EMAIL_UNACCEPTED_ORG_INVITE_REMINDER,
  EXP_SWIMLANES_AA,
  EXP_ANON_SWIMLANES_AA,
  EXP_GOOGLE_ONE_TAP_SIGNUP_LOGIN,
  EXP_CONSOLIDATE_SIGNUP_MODAL,
  ROLLOUT_SDK_PICTURE_IN_PICTURE_WITH_RECORD_REPLY,
  ROLLOUT_SDK_PICTURE_IN_PICTURE_WITH_PERSISTENT_RECORD,
  ROLLOUT_DESTINATION_FEED_V2,
  SUGGEST_PUBLISH_ON_PUBLIC_CHANNEL_LOOM_SHARE,
  MARKETING_SITE_THREAD_PRICING_PAGE,
  EXP_MORE_OPINIONATED_OAUTH_ON_SIGNUP_PAGE,
  EXP_MORE_OPINIONATED_OAUTH_ON_SIGNUP_PAGE_MOBILE,
  EXP_SHARE_PAGE_END_OF_VIDEO_NUDGES,
  EXP_EMBED_END_OF_VIDEO_NUDGES,
  EXP_SHARE_PAGE_PAUSE_VIDEO_NUDGES,
  EXP_EMBED_PAUSE_VIDEO_NUDGES,
  MARKETING_SITE_THREAD_HOMEPAGE,
  EXP_INVITE_MODAL_UPDATE,
  EXP_EMAIL_VERIFICATION_REMINDER,
  VIDEO_PLAYER_FRESH,
  EXP_INVITE_MODAL_UPDATE_MOBILE,
  EXP_NEW_CTA_AND_VALUE_PROP_ON_SHARE_PAGE,
  EXP_INVITE_LINK_ONBOARDING,
  MARKETING_SITE_THREAD_HOMEPAGE_AB_v1,
];

export const FEATURE_FLAGS_FOR_ADMIN = [
  ANDROID_AUDIO_ONLY_LOOMS,
  IOS_AUDIO_ONLY_LOOMS,
  ROLLOUT_FILE_ATTACHMENTS,
  ROLLOUT_LOOM_ACTIVITY_FEED,
  ROLLOUT_WEBSITE_RECORDING,
  ROLLOUT_GRAPHQL_GET_VIDEOS_DASHBOARD,
  ROLLOUT_DUPLICATE_FOLDER,
  ROLLOUT_DELIGHT_LOOM_TV,
  ROLLOUT_SHOW_DEACTIVATE_MEMBER_BUTTON,
  ROLLOUT_DECODE_DURATION,
  ROLLOUT_VIDEO_UPLOADS,
  ROLLOUT_COMPANY_DEFAULT_WORKSPACE,
  ROLLOUT_COMPANY_DEFAULT_WORKSPACE_UI,
  ROLLOUT_COMPANY_AUTH_CONFIG,
  ROLLOUT_COMPANY_SCIM_SETTINGS,
  ROLLOUT_COMPANY_TEST_SSO_CONNECTION,
  ROLLOUT_COMPANY_SSO_GSUITE,
  ROLLOUT_COMPANY_SSO_AZURE,
  ROLLOUT_COMPANY_SSO_ONELOGIN,
  ROLLOUT_COMPANY_SSO_AUTH0,
  ROLLOUT_COMPANY_SSO_ADFS,
  SUGGEST_PUBLISH_ON_PUBLIC_CHANNEL_LOOM_SHARE,
  ROLLOUT_VIRUS_SCAN,
  ROLLOUT_VIDEO_LIMIT_BANNER,
  ROLLOUT_RECORDING_TIMER,
  ROLLOUT_TRANSCRIPTION_CORRECTION,
  ROLLOUT_TRANSCRIPTION_ENTERPRISE,
  ROLLOUT_TRANSCRIPTION_BUSINESS,
  ROLLOUT_IN_TRANSCRIPT_SEARCH,
  ROLLOUT_CLOSED_CAPTIONS,
  ROLLOUT_INSTANT_EDITING,
  ROLLOUT_JIT_HLS_NOTRIMMING,
  ROLLOUT_SHOW_REACTION_FLURRIES,
  ROLLOUT_WELCOME_LOOM,
  ROLLOUT_VIDEO_PLAYER_PRE_PLAY_SCREEN,
  ROLLOUT_VIDEO_PLAYER_END_SCREEN,
  ROLLOUT_SLACK_IDENTITY_LINKS,
  ROLLOUT_SLACK_IDENTITY_LINKS_ONBOARDING_MODAL,
  ROLLOUT_SLACK_SHARED_AUTH_PRIVATE,
  ROLLOUT_SLACK_SHARED_AUTH_PUBLIC,
  ROLLOUT_SIGNUP_MODAL_FROM_SHARE_PAGE,
  ROLLOUT_NEW_ANONYMOUS_REACTION_NAME_INPUT,
  ROLLOUT_V4_AVSERVER,
  EXPERIMENT_SHARE_WITH_LOOM_TEAM,
  EXP_VIDEO_LIMIT_PAYWALL,
  GROW_DASHBOARD_NAV_PRICING_LINKS,
  GROW_ACT_CLARIFY_TRIAL,
  GROW_PRICING_HEADER_COPY,
  GROW_ENGAGE_REMOVE_VIEWER_INFO_BARRIER,
  GROW_ACT_GET_STARTED,
  GROW_RICHER_FIRST_VIEW_EMAIL,
  GROW_DASHBOARD_RECORD_BUTTON,
  GROW_END_OF_VIDEO_REPLY_CTA,
  EXP_FIRST_VIDEO_SHARE_MODAL,
  SEND_HLS_PLAYBACK_STATS,
  SHOW_MARKETING_BANNER,
  MARKETING_BANNER_COPY,
  ADMIN_DOMAIN_STATUS_PROCESS_LIMIT,
  MULTIPLE_WORKSPACES,
  VIDEO_UPLOADS_FILE_SIZE_LIMIT,
  ROLLOUT_RECOVER_VIDEOS,
  SHOW_MOBILE_APP_CARD,
  DARK_MODE_TOGGLE,
  DEFAULT_TEAM_ACCOUNT_TYPE,
  ROLLOUT_INTEGRATIONS_LISTING,
  ROLLOUT_INTEGRATIONS_DATASYNC,
  ROLLOUT_INTEGRATIONS_ZOOM,
  ROLLOUT_INTEGRATIONS_ZOOM_NOTIFICATION,
  ROLLOUT_INTEGRATIONS_ZOOM_GA_UI,
  ROLLOUT_SLACK_NOTIFICATIONS,
  ROLLOUT_DASHBOARD_WATCH_LATER,
  HIDE_DURING_DOWNTIME,
  ROLLOUT_WORKSPACE_CONSOLIDATE,
  ROLLOUT_WORKSPACE_CONSOLIDATE_ADMIN_SETTINGS,
  ROLLOUT_WORKSPACE_CONSOLIDATE_EXISTING_USERS,
  ROLLOUT_WORKSPACE_CONSOLIDATE_EXISTING_USERS_SIDEBAR,
  ROLLOUT_WORKSPACE_CONSOLIDATE_EXISTING_USERS_SELECTOR,
  ROLLOUT_ONESIGNAL_NOTIFICATIONS,
  CONFIG_HLS_JS_PLAYER,
  CONFIG_WELCOME_LOOMS_IDS,
  EXP_SIGNUP_MODAL_SHARE_PAGE,
  ENABLE_CUSTOM_INVOICE,
  EXPERIMENT_ACTIVITY_FEED,
  ROLLOUT_AUDIT_LOG_EXPORT,
  DISABLE_EXTENSION_DOWNLOAD,
  ROLLOUT_CAM_BUBBLE_ON_BOARDING,
  ROLLOUT_WORKSPACE_CONTACT_SYNC_SLACK,
  ROLLOUT_WORKSPACE_CONTACT_SYNC_GOOGLE,
  QUEUE_BASE_TRANSCODER_V3_INCLUDE_HLS,
  EXP_INVITE_MAGIC_LINK,
  EXP_PERSISTENT_RECORD_BUTTON_SIGNED_IN,
  EXP_PERSISTENT_RECORD_BUTTON_SIGNED_OUT,
  EXP_VIEWFINDER_PROTOTYPE,
  MEMBER_LIMITS_OVERRIDE_FLAG,
  EXP_SDK_IN_ONBOARDING,
  ROLLOUT_WEAVE,
  EXP_INVITE_STORAGE_INCENTIVES,
  EXP_INVITE_STORAGE_INCENTIVES_V2,
  EXP_INVITE_STORAGE_INCENTIVES_ROLLOUT,
  EXPERIMENT_LOOM_COMPANION_BEAM,
  ROLLOUT_PRIVATE_VIDEO_PREVIEW,
  ROLLOUT_SDK_PRIVATE_KEY,
  ROLLOUT_SDK_PRIVATE_KEY_ROUTES,
  ROLLOUT_INTEGRATIONS_ZOOM,
  ROLLOUT_INTEGRATIONS_ZOOM_NOTIFICATION,
  ROLLOUT_INTEGRATIONS_ZOOM_GA_UI,
  ROLLOUT_GENERATED_METADATA,
  EXPERIMENT_RENAME_CTA,
  ROLLOUT_SDK_FTUX_ONBOARDING,
  EXP_JOIN_WORKSPACE_FROM_SHARE_PAGE,
  EXP_MOBILE_NUDGE_IN_ONBOARDING_CHECKLIST,
  EXP_GOOGLE_ONE_TAP_SHARE_PAGE,
  EXPERIMENT_EMAIL_ORG_INVITE_ACCEPTED,
  EXPERIMENT_EMAIL_UNACCEPTED_ORG_INVITE_REMINDER,
  EXP_SWIMLANES_AA,
  EXP_ANON_SWIMLANES_AA,
  EXP_GOOGLE_ONE_TAP_SIGNUP_LOGIN,
  EXP_CONSOLIDATE_SIGNUP_MODAL,
  ROLLOUT_SDK_PICTURE_IN_PICTURE_WITH_RECORD_REPLY,
  ROLLOUT_SDK_PICTURE_IN_PICTURE_WITH_PERSISTENT_RECORD,
  EXP_DESTINATION_EXPANDED_BETA,
  ROLLOUT_DESTINATION_FEED_V2,
  MARKETING_SITE_THREAD_PRICING_PAGE,
  EXP_MORE_OPINIONATED_OAUTH_ON_SIGNUP_PAGE,
  EXP_MORE_OPINIONATED_OAUTH_ON_SIGNUP_PAGE_MOBILE,
  EXP_SHARE_PAGE_END_OF_VIDEO_NUDGES,
  EXP_EMBED_END_OF_VIDEO_NUDGES,
  EXP_SHARE_PAGE_PAUSE_VIDEO_NUDGES,
  EXP_EMBED_PAUSE_VIDEO_NUDGES,
  MARKETING_SITE_THREAD_HOMEPAGE,
  EXP_INVITE_MODAL_UPDATE,
  EXP_EMAIL_VERIFICATION_REMINDER,
  RABBITMQ_CONSUMER_STARTUP_CONTROL,
  EXP_INVITE_MODAL_UPDATE_MOBILE,
  EXP_NEW_CTA_AND_VALUE_PROP_ON_SHARE_PAGE,
  RABBITMQ_CONSUMER_CONNECTION_RETRIES,
  RABBITMQ_PUBLISHER_CONNECTION_RETRIES,
  EXP_INVITE_LINK_ONBOARDING,
  MARKETING_SITE_THREAD_HOMEPAGE_AB_v1,
];

export const VARIANT = ['variant'];

export const inactiveDefaultVariations = [
  'control',
  'dummy-control',
  'ineligible',
  'dummy-variant',
];

/**
 Some high-volume experiments may flood segment with events.  We can mitigate that by defining
 a list of values for certain flags that shouldn't send analytics events. Only flags included in FEATURE_FLAGS_ANALYTICS_LIST
 are relevant.  An example config that would prevent any 'ineligible' flag values for the 'experiment_flag_name'
 flag looks like the following. Any additional flag values that shouldn't be logged to segment would be
 added to the array.

export const SEGMENT_EVENT_IGNORE_LIST = {
  'experiment_flag_name': ['ineligible']
}
 */
export const SEGMENT_EVENT_IGNORE_LIST = {
  'experiment-loom-companion-beam': [
    'active',
    'ineligible',
    'ineligible-request-source',
    'ineligible-logged-in',
    'ineligible-recording-limit',
    'ineligible-workspace-role',
    'ineligible-scopes',
  ],
};
